// Use our canonical React instance
import { React, ReactDOMClient } from './lib/react';
import App from './App.tsx'
import './index.css'

// Make sure React is available globally
window.React = React;

// Ensure the root element exists
const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error("Root element not found");
} else {
  // Use the client from our canonical import
  ReactDOMClient.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
